import EventEmitter from "events"

const events = new EventEmitter()

export const resetListeners = () => {
  events.eventNames().forEach((name) => events.removeAllListeners(name))
}

export default events
